import styled from 'styled-components';

const Wrapper = styled.div`
  overflow: hidden;
  margin: 0px;

  .person-skeleton-wrapper {
    display: flex;
    flex-direction: column;
   .person-box {
    width: 100%;
    height: 110px;
    border-radius: 13px;
    margin: 0px auto 15px auto;
    }
   .title-box {
     height: 20px;
     border-radius: 25px;
     width: 100%;
     margin: 5px auto 20px auto;
   }
  }
  .skeleton-box {
    height: 20px;
    border-radius: 25px;
    width: 50px;
  }
  .btn {
    border-radius: 25px;
    width: 94px;
    height: 40px;
    margin: 0 auto;
  }
`;

const IndustriesSkeleton = function IndustriesSkeleton() {
  return (
    <Wrapper>
      <div className="person-skeleton-wrapper">
        <span className="skeleton-box person-box" />
        <span className="skeleton-box title-box" />
      </div>
    </Wrapper>
  );
};

export default IndustriesSkeleton;
